import { ReactNode } from "react";
import { AlertColor } from "@mui/material";
import { create } from "zustand";

interface NotificationStore extends NotificationState {
  addNotification: (notification: NotificationState) => void;
  clearNotification: () => void;
}

export interface NotificationState {
  open?: boolean;
  type?: AlertColor;
  message?: string | ReactNode;
  timeout?: number | null;
  autoClose?: boolean;
}

export const notificationInitialState: NotificationState = {
  open: false,
  type: "info",
  message: "",
  timeout: 5000,
  autoClose: true,
};

export const useNotificationStore = create<NotificationStore>((set, get) => ({
  ...notificationInitialState,
  addNotification: (notification: NotificationState) => {
    set({ ...notification, open: true });
  },
  clearNotification: () => set({ open: false }),
}));
